export interface GuideBox {
  top: number;
  left: number;
  width: number;
  height: number;
}

/** Places the card below the target, or above it when the bottom of the screen is too close. */
export function placeGuideCard(
  target: GuideBox,
  cardWidth: number,
  cardHeight: number,
  viewport: { width: number; height: number }
): { top: number; left: number } {
  const gap = 12;
  const margin = 12;
  let top = target.top + target.height + gap;
  if (top + cardHeight > viewport.height - margin) {
    top = target.top - gap - cardHeight;
  }
  if (top < margin) {
    top = margin;
  }
  let left = target.left;
  if (left + cardWidth > viewport.width - margin) {
    left = viewport.width - cardWidth - margin;
  }
  if (left < margin) {
    left = margin;
  }
  return { top, left };
}
